// src/api_scripts/createUser Profile.js
import { createApiClient } from "../apiClient";

const createUserProfile = async (userProfileData, orgId, accessToken, setProgress) => {
  const { name } = userProfileData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create User Profile: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // API endpoint for creating a new  User Profile
  const relativeUri = `organization/${orgId}/user-profile`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, userProfileData);

    const newUserProfile = response.data; // The API returns the created resource directly

    console.log("Create User Profile API Response Data:", newUserProfile);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created User Profile "${name}" (ID: ${newUserProfile.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newUserProfile.id; // Return the created override list object (includes its ID)

  } catch (error) {
    console.error(`Error creating User Profile "${name}":`, error);

    let errorMessage = `Error creating User Profile "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createUserProfile;
